import React from 'react';
import * as FiIcons from 'react-icons/fi';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SafeIcon from '../../common/SafeIcon';

const Testimonials = () => {
  const { FiMessageSquare, FiStar } = FiIcons;

  const reviews = [
    { quote: "Since partnering with NewYorkCitySEO.agency, our legal practice dominates the local map pack. Our organic leads have tripled, and we are now the top recommended entity when users ask ChatGPT for legal advice in NYC.", author: "David R.", role: "Legal Services Industry", borough: "Manhattan" },
    { quote: "The technical SEO fixes and content strategy transformed our online presence. We went from page 4 to ranking #1 for highly competitive dining and hospitality terms. Their GEO approach is ahead of the curve.", author: "Sarah J.", role: "Hospitality & Dining Industry", borough: "Brooklyn" },
    { quote: "As a technology company in SoHo, we needed aggressive growth. Their AI Search Optimization and enterprise SEO strategies helped us outrank massive competitors for crucial software industry keywords.", author: "Michael T.", role: "SaaS & Technology Industry", borough: "SoHo, NYC" }
  ];

  return (
    <section className="py-24 bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">Proven Results in the Concrete Jungle</h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">See how we drive verifiable traffic and revenue growth for New York City's top industries and professional sectors.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, i) => (
            <AnimatedSection key={i} delay={i * 0.2}>
              <div className="glass-panel p-8 rounded-2xl relative h-full border border-slate-800 hover:border-blue-500/30 transition-colors">
                <SafeIcon icon={FiMessageSquare} className="text-4xl text-blue-900/50 absolute top-6 right-6" />
                <div className="flex text-yellow-500 mb-6">
                  {[...Array(5)].map((_, j) => (
                    <SafeIcon key={j} icon={FiStar} className="fill-current text-sm" />
                  ))}
                </div>
                <p className="text-slate-300 mb-8 italic leading-relaxed">"{review.quote}"</p>
                <div className="mt-auto">
                  <div className="text-white font-bold">{review.author}</div>
                  <div className="text-sm text-slate-400 font-medium">{review.role}</div>
                  <div className="text-xs text-blue-500 mt-1 font-bold uppercase tracking-wider">{review.borough}</div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;